export const LOGIN_TYPE_PIIVO = 'login_type_piivo';
